import { create } from 'zustand';
import type { FeatureFlags } from '@lynx-crypto/contracts/feature-flags';

/**
 * Holds the platform feature-flag map fetched from the public /auth/status
 * endpoint (the SAME complete, registry-merged map the backend enforces with).
 * Populated once at app startup by SetupGuard, then consulted by the sidebar,
 * the route guards, and any page that wants to hide a disabled capability.
 *
 * The actual enable/deny decision uses the SHARED resolver
 * `isFeatureEnabledForUser` from @lynx-crypto/contracts — this store only carries
 * the data. There is no forked client-side gating logic.
 */
type FeatureFlagState = {
  flags: FeatureFlags | null;
  /** True once /auth/status has been read (success or fail). */
  loaded: boolean;
  setFlags: (flags: FeatureFlags) => void;
};

export const useFeatureFlagStore = create<FeatureFlagState>((set) => ({
  flags: null,
  loaded: false,
  setFlags: (flags) => set({ flags, loaded: true }),
}));
